export const FrameIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.9 2.25H3.85V4.35H1.75L1.75 5.4H3.85V9.6H1.75L1.75 10.65H3.85V12.75H4.9V10.65H9.1V12.75H10.15V10.65H12.25V9.6H10.15V5.4H12.25V4.35H10.15V2.25H9.1V4.35L4.9 4.35V2.25ZM9.1 9.6V5.4L4.9 5.4V9.6L9.1 9.6Z"
      />
    </svg>
  );
};
